import { MenubarMobile } from '../../areas/Menubar/Mobile/MenubarMobile';
export class MobileClasses {
    MenubarMobile = MenubarMobile;
}
